// extracted by mini-css-extract-plugin
export default {"main":"LpPage_main__II8Ul","title":"LpPage_title__-zium"};